import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "casebox flex f-d a-c" }
const _hoisted_2 = {
  key: 0,
  class: "teamList"
}
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "contect" }
const _hoisted_6 = { class: "position flex" }
const _hoisted_7 = { style: {"color":"lightgray","margin-left":"2rem"} }
const _hoisted_8 = {
  key: 0,
  class: "labelList flex"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", null, "标签:", -1)
const _hoisted_10 = {
  key: 1,
  class: "labelList flex"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", null, "标签:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", null, "暂无标签", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "description" }
const _hoisted_15 = { class: "delate flex a-c j-c" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "teamList"
}

import { onMounted, ref, watch } from "vue";
import Padding from "@/components/Layout/paging.vue";
import NotYetOpen from "@/components/NotYetOpen.vue";
import { RoleTypeName } from "@/services/datatype/entity/RoleTypeName";

export default /*#__PURE__*/_defineComponent({
  __name: 'Team',
  props: {
    teamList: null
  },
  emits: ["deleteMember", "addPerson"],
  setup(__props: any, { emit }) {

const props = __props as { teamList };

const newData = ref([]);


let teamList = ref([]);
const getDataOne = (data) => {
  newData.value = data;
};

const deleteMember = (item) => {
  // 3为发布案例
  emit("deleteMember", item);
};
const addPerson = () => {
  // 3为发布案例
  emit("addPerson");
};
const getList = () => {
  teamList.value.splice(0, teamList.value.length);
  teamList.value.push(...props.teamList);
};
watch(
  () => {
    return props.teamList.length;
  },
  () => {
    getList();
  }
);

onMounted(() => {
  getList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, { onClick: addPerson }, {
      default: _withCtx(() => [
        _createTextVNode("添加新的团队成员")
      ]),
      _: 1
    }),
    (_unref(teamList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newData.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "team flex j-s-b",
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: item.logo,
                  alt: ""
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h1", null, "律师名称：" + _toDisplayString(item.name), 1),
                  _createElementVNode("h1", _hoisted_7, " 职务：" + _toDisplayString(_unref(RoleTypeName).getDisplayName(item.roleType) || "暂无职位"), 1)
                ]),
                (item.keywords)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.keywords, (item1, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "label",
                          key: index
                        }, _toDisplayString(item1), 1))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13)),
                _createElementVNode("div", _hoisted_14, " 内容：" + _toDisplayString(item.description || "暂无内容"), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h1", {
                  onClick: ($event: any) => (deleteMember(item))
                }, "删除", 8, _hoisted_16)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(NotYetOpen, { data: "还没有成员哦!" })
        ])),
    _withDirectives(_createVNode(Padding, {
      data: _unref(teamList),
      "page-size": 2,
      onGetData: getDataOne
    }, null, 8, ["data"]), [
      [_vShow, _unref(teamList).length > 0]
    ])
  ]))
}
}

})